import { api } from './client';

// Teams API
export const teamsApi = {
  getAll: () => api.get<{ teams: import('../types').Team[] }>('/teams'),

  getById: (id: string) =>
    api.get<{
      team: import('../types').Team;
      members: import('../types').TeamMember[];
      projects: import('../types').Project[];
      userRole: string | null;
    }>(`/teams/${id}`),

  create: (data: { name: string; description?: string }) =>
    api.post<{ team: import('../types').Team }>('/teams', data),

  update: (id: string, data: { name?: string; description?: string }) =>
    api.patch<{ team: import('../types').Team }>(`/teams/${id}`, data),

  delete: (id: string) => api.delete<{ message: string }>(`/teams/${id}`),

  addMember: (teamId: string, userId: string, role?: string) =>
    api.post(`/teams/${teamId}/members`, { user_id: userId, role }),

  updateMember: (teamId: string, userId: string, role: string) =>
    api.patch(`/teams/${teamId}/members/${userId}`, { role }),

  removeMember: (teamId: string, userId: string) =>
    api.delete(`/teams/${teamId}/members/${userId}`),
};
